// removed by extract-text-webpack-plugin
module.exports = {"contacts":"index__contacts___3Zs64","contact":"index__contact___2eSh0","name":"index__name___2-ksK","mail":"index__mail___7EgMZ","fadein":"index__fadein___15Sid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/contacts/index.scss
// module id = 389
// module chunks = 0